<section class="role-access-shell">
  <div *ngIf="loading" class="role-access-status">
    Loading Role Access...
  </div>

  <div *ngIf="error" class="role-access-status role-access-status-error">
    {{ error }}
  </div>

  <div
    #remoteRoot
    class="role-access-root"
    [class.role-access-root-hidden]="loading || !!error"
  ></div>
</section>
